// 从 '/auto' 导入以获得完整的 TypeScript 支持
import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
// 直接导入自动生成的路由配置
import { handleHotUpdate, routes } from 'vue-router/auto-routes'
import { setupLayouts } from 'virtual:generated-layouts'
import { trackPageView } from '@/plugins/analytics'
const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(routes as RouteRecordRaw[]),

  scrollBehavior() {
    return { left: 0, top: 0, behavior: 'smooth' }
  },
})

router.afterEach((to) => {
  trackPageView(to.fullPath, document.title)
})

export default router

if (import.meta.hot) {
  handleHotUpdate(router)
}
